import { WeatherSunnyAlertIcon } from './WeatherSunnyAlertIcon';

/**
 * author: Michael Irigoyen
 * id 3AACF641-3923-4DBA-9568-0680999A6548
 * name weather-sunny-alert
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-sunny-alert.svg
 * tags
 * - Weather 
 * - Alert / Error 
 * - Home Automation 
 */
export const SunAdvisoryIcon = WeatherSunnyAlertIcon;
export default SunAdvisoryIcon